// extracted by mini-css-extract-plugin
export default {"client_heading":"styles_client_heading__xKDRZ","testimonial_message":"styles_testimonial_message__UIPhl"};